var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"googledrive"},[_c('video',{key:_vm.videoId,staticClass:"video-js vjs-default-skin",attrs:{"id":"gdriveplayer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }